// API Configuration
// Empty string = same-origin proxy (local dev via CRA proxy)
// Undefined/missing = production default
const rawPlatformUrl = process.env.REACT_APP_PLATFORM_API_URL;
export const API_CONFIG = {
  platformUrl: rawPlatformUrl != null ? rawPlatformUrl : 'https://platform.trucontext.ai',
  dataPlaneUrl: process.env.REACT_APP_DATA_PLANE_API_URL || 'https://api.trucontext.ai',
  authUrl: process.env.REACT_APP_AUTH_URL || 'https://auth.trucontext.ai',
  wsUrl: process.env.REACT_APP_WS_URL || 'wss://szpu6hw2nb.execute-api.us-east-1.amazonaws.com/prod',
};

// Cognito Configuration
export const COGNITO_CONFIG = {
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_5Bba25tjJ',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '7tn0f7guijnoa0ue0d7258opfg',
  domain: process.env.REACT_APP_COGNITO_DOMAIN || 'auth.trucontext.ai',
  redirectUri: process.env.REACT_APP_REDIRECT_URI || 'https://app.trucontext.ai/auth/callback',
  logoutUri: process.env.REACT_APP_LOGOUT_URI || 'https://app.trucontext.ai/login',
};

// OAuth URLs
export const getGoogleOAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: COGNITO_CONFIG.clientId,
    response_type: 'code',
    scope: 'email openid profile',
    redirect_uri: COGNITO_CONFIG.redirectUri,
    identity_provider: 'Google',
  });

  return `https://${COGNITO_CONFIG.domain}/oauth2/authorize?${params.toString()}`;
};

export const getCognitoLoginUrl = () => {
  const params = new URLSearchParams({
    client_id: COGNITO_CONFIG.clientId,
    response_type: 'code',
    scope: 'email openid profile',
    redirect_uri: COGNITO_CONFIG.redirectUri,
  });

  return `https://${COGNITO_CONFIG.domain}/login?${params.toString()}`;
};

export const getCognitoLogoutUrl = () => {
  const params = new URLSearchParams({
    client_id: COGNITO_CONFIG.clientId,
    logout_uri: COGNITO_CONFIG.logoutUri,
  });

  return `https://${COGNITO_CONFIG.domain}/logout?${params.toString()}`;
};
